import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";
import { whyChooseFeatures } from "../lib/data";
import { Icon } from "./Icon";
import SectionHeading from "./SectionHeading";

const WhyChoose = () => {
  const { t, lang } = useLanguage();

  return (
    <section className="py-24 md:py-32" data-testid="why-choose-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <SectionHeading label={t.whyChoose.label} title={t.whyChoose.heading} sub={t.whyChoose.sub} center />

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {whyChooseFeatures.map((f, i) => {
            const d = f[lang];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.45, delay: (i % 3) * 0.08 }}
                className="group relative bg-[#11203A] border border-white/12 p-8 hover:bg-[#1A2C47] hover:-translate-y-1.5 transition-all duration-300 overflow-hidden"
                data-testid={`why-feature-${i}`}
              >
                <div className="absolute -top-10 -end-10 w-28 h-28 rounded-full bg-[#D4AF37]/0 group-hover:bg-[#D4AF37]/5 transition-colors duration-500" />
                <div className="relative w-12 h-12 grid place-items-center border border-[#D4AF37]/30 text-[#D4AF37] group-hover:bg-[#D4AF37] group-hover:text-[#0A1223] transition-colors duration-300">
                  <Icon name={f.icon} size={22} />
                </div>
                <h3 className="relative font-heading text-lg font-bold text-white mt-6">{d.title}</h3>
                <p className="relative mt-3 text-sm text-slate-300 leading-relaxed">{d.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
